import axios from "./axiosInstance";
import {Event} from '../types/eventTypes'
import {Clip, GroupedClips} from "../types/clipTypes";
import {Stream, Track} from "../types/dataSourceTypes";
const baseUrl = process.env.REACT_APP_BASE_URL+"/match";

export async function getEventById(eventId: string) {
    const response = await axios.get(`${baseUrl}/${eventId}`)
    return response.data;
}

export async function getMatchClips(eventId: string, abortController: AbortController | null = null): Promise<GroupedClips> {
    const response = abortController ? await axios.get(`${baseUrl}/${eventId}/groupedClips`, {signal: abortController?.signal}) : await axios.get(`${baseUrl}/${eventId}/groupedClips`)
    return response.data;
}

export async function getMatchOptions() {
    const response = await axios.get(process.env.REACT_APP_BASE_URL + '/match/options' || '');
    return response.data;
}

export async function fillEvent(streamDataSource: Stream, streamUrl: string, streamTracks: Track[], fileDataSource: any, filePath: string, fileTracks: Track[], event: Event): Promise<any> {
    const body = {
        streamDataSource: streamDataSource,
        streamUrl: streamUrl,
        streamTracks: streamTracks,
        filePath: filePath,
        fileTracks: fileTracks,
        fileDataSource: fileDataSource,
        event: event
    }
    const response = await axios.post(`${baseUrl}/fillEvent`, body);
    return response.data;
}

export async function deleteAllClips(eventId: string): Promise<any> {
    const response = await axios.delete(`${baseUrl}/${eventId}/allClips`);
    return response.data;
}

export async function getJobGroupedFastClips(eventId: string){
    const response = await axios.get(`${baseUrl}/${eventId}/fastJobGroupedClips`)
    return response.data;
}